import { ContactAddressType } from '../common/ContactAddress.type'
import { LoginUser } from '../common/LoginUser.type'
import { User } from '../common/User.type'

export const fullName = (
  user: User | ContactAddressType | LoginUser,
): string => {
  let wkName = "連絡先"
  if (('lastName' in user && 'firstName' in user) && (user.lastName && user.firstName)) {
    wkName = user.lastName + user.firstName
  }
  else if ('contactName' in user && user.contactName) {
    wkName = user.contactName
  }
  return wkName
}
